import { Menu } from '@chakra-ui/react';
import { ReactNode, useCallback } from 'react';

import { MenuContent, MenuRadioItemGroup, MenuRoot } from '../Menu';
import { DropdownAnchor } from './Anchor';

type TDropdown = {
  children: ReactNode;
  anchorContent: ReactNode;
  dataTestid?: string;
  onItemSelect?: (value: string | number) => void;
  selectedValue?: string;
  anchorSpacing?: string[];
  withChevronIcon?: boolean;
  portalled?: boolean;
};

const defaultSpacing: string[] = [];

export const Dropdown = ({
  children,
  anchorContent,
  onItemSelect,
  selectedValue,
  anchorSpacing = defaultSpacing,
  withChevronIcon,
  dataTestid,
  portalled = true,
  ...props
}: TDropdown & Menu.RootProps) => {
  const onSelect = useCallback(
    ({ value }: { value: string | number }) => {
      if (onItemSelect) {
        onItemSelect(value);
      }
    },
    [onItemSelect]
  );

  return (
    <MenuRoot {...props} onSelect={onSelect}>
      {({ open }: { open: boolean }) => (
        <>
          <DropdownAnchor
            anchorContent={anchorContent}
            open={open}
            spacing={anchorSpacing}
            withChevronIcon={withChevronIcon}
            dataTestid={dataTestid}
          />
          <MenuContent portalled={portalled}>
            <MenuRadioItemGroup value={selectedValue}>
              {children}
            </MenuRadioItemGroup>
          </MenuContent>
        </>
      )}
    </MenuRoot>
  );
};
